import { Header } from "../components/Header";
import { contacts } from "../data/profile";

const steps = [
  "Tell me your goal and timeline",
  "Share references or the challenges you are facing",
  "Get a clear technical and visual direction"
];

export function ContactsPage() {
  return (
    <>
      <Header />
      <main className="listing-shell contacts-shell">
        <section className="page-hero compact-hero contact-hero">
          <span>/contact</span>
          <h1>Turn your idea into a product.</h1>
          <p>
            Recruiting, starting a business or looking for technical support? Send me a message. A clear goal helps us find the right solution faster.
          </p>
        </section>

        <section className="contact-action-band">
          <div>
            <h2>What should your first message include?</h2>
            <p>A good brief does not need to be long. It needs to be clear.</p>
          </div>
          <ol>
            {steps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        </section>

        <section className="contact-grid" aria-label="Contact channels">
          {contacts.map((contact) => (
            <a className={`contact-card ${contact.tone}`} href={contact.href} key={contact.href} rel="noreferrer" target={contact.href.startsWith("mailto:") ? undefined : "_blank"}>
              <span>{contact.label}</span>
              <strong>{contact.handle}</strong>
              <i>→</i>
            </a>
          ))}
        </section>
      </main>
    </>
  );
}
